global.jQuery = global.$ = window.jQuery = require('jquery');
require('easing');
require('velocity');
require('TweenMax');
require('inview');
require('jquery.scrolline');
var ScrollMagic = require('ScrollMagic');
var skrollr = require('skrollr');
var Swiper = require('swiper');

(function () {
	'use strict';
	$(function () {

		/*---------------------------------------------
		ハンバーガーメニュー
		---------------------------------------------*/

		/* var flag = false,
			$navGlobal = $('.l-navGlobal'),
			$humberger = $('.c-humberger');

		$humberger.on('click', function () {
			if (!flag) {
				$humberger.addClass('is-active');
				$navGlobal.fadeIn(function () {
					flag = true;
				});

				var h = $('.l-header').outerHeight();

				var wH = $(window).height();
				$('.l-navGlobal, .l-navGlobal__inner').css('height', wH - h + 2 + 'px');

			} else {
				$humberger.removeClass('is-active');
				$navGlobal.fadeOut(function () {
					flag = false;
				});
			}
		});

		$('.l-navGlobal__item a').on('click', function () {
			$navGlobal.fadeOut();
			$humberger.removeClass('is-active');
		}); */

		/*--------------------------------------------------------------------------*
		 * スムーズスクロール
		 *--------------------------------------------------------------------------*/

		$('a[href^="#"]').click(function () {
			var speed = 500;
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			$("html, body").animate({
				scrollTop: position
			}, speed, "swing");
			return false;
		});

		/*---------------------------------------------
		リンク消去
		---------------------------------------------*/

		$('.js-disable').click(function () {
			return false;
		});

	});

	/*--------------------------------------------------------------------------*
	 * inveiw
	 *--------------------------------------------------------------------------*/

	$('.js-view').css('opacity', '0');

	$('.js-view').on('inview', function () {
		$(this).delay(350).animate({
			opacity: '1'
		}, 700);
	});

}).call(this);


/*---------------------------------------------
	skrollr setting
---------------------------------------------*/

var isMobile = false;

isMobile = $('html').is('.skrollr-mb');

if (!isMobile) {
	window.onload = function () {
		var s = skrollr.init({
			forceHeight: false,
			mobileDeceleration: 0.01,
			mobileCheck: function () {
				return isMobile;
			}
		});
	}
}


/*---------------------------------------------
	header paddingTop
---------------------------------------------*/

/* var h = $('.l-header').outerHeight();

$('.l-main').css('padding-top', h + 'px');

var h2 = $('.scrolldown02').outerHeight();
var wH = $(window).height();

$('.swiper-pagination').css('height', wH - h - h2 + 'px');

$(function(){
	var wW = $(window).width();

    if(768 > wW){
        $('.swiper-pagination').css('height', wH - h - h2 + 'px');
    } else if(wW >  wH) {
        $('.swiper-pagination').css('height', wH - h - h2 + 'px');
    } else {
        $('.swiper-pagination').css('height', 100 + '%');
    }
}); */

/*---------------------------------------------
	swiper
---------------------------------------------*/


/* var id_01 = document.getElementById('animation1');
var id_02 = document.getElementById('animation2');
var id_03 = document.getElementById('animation3');
var id_04 = document.getElementById('animation4');

var topSwiper = new Swiper('.p-hero', {
	initialSlide: 0,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	autoplay: {
		delay: 6000,
		disableOnInteraction: false,
	},
	spaceBetween: 0,
	effect: 'fade',
	loop: true,
});

topSwiper.on('slideChangeTransitionStart', function () {
	id_01.beginElement();
	id_02.beginElement();
});

$(window).on('load', function () {
	id_03.beginElement();
	id_04.beginElement();
}); */

/*---------------------------------------------
	icon top
---------------------------------------------*/

var scrollDown01 = $('.scrolldown01');
var scrollDown02 = $('.scrolldown02');

$(window).scroll(function () {
	if ($(this).scrollTop() > 100) {
		scrollDown02.fadeOut(200);
		scrollDown01.fadeIn(200);
	} else {
		scrollDown02.fadeIn(200);
		scrollDown01.fadeOut(200);
	}
});


/*---------------------------------------------
	gnav active
---------------------------------------------*/

/* $(function () {
	var scrollMenu = function () {
		// 配列宣言
		var array = {
			'#hero': 0,
			'#return': 0,
			'#merit': 0,
			'#point': 0,
			'#area': 0,
			'#link': 0
		};

		var $globalNavi = new Array();

		// 各要素のスクロール値を保存
		for (var key in array) {
			if ($(key).offset()) {
				array[key] = $(key).offset().top - 10;
				$globalNavi[key] = $('.l-navGlobal ul li a[href="' + key + '"]');
			}
		}

		// スクロールイベントで判定
		$(window).scroll(function () {
			for (var key in array) {
				if ($(window).scrollTop() > array[key] - 50) {
					$('.l-navGlobal ul li a').each(function () {
						$(this).removeClass('active');
					});
					$globalNavi[key].addClass('active');
				}
			}
		});
	}

	// 実行
	scrollMenu();
}); */


/*---------------------------------------------
	accordion
---------------------------------------------*/
//アコーディオンをクリックした時の動作
$('.accordion-title').on('click', function() {//タイトル要素をクリックしたら
	var findElm = $(this).prev(".accordion-box");//直後のアコーディオンを行うエリアを取得し
	$(findElm).slideToggle();//アコーディオンの上下動作
    
	if($(this).hasClass('close')){//タイトル要素にクラス名closeがあれば
		$(this).removeClass('close');//クラス名を除去し
	}else{//それ以外は
		$(this).addClass('close');//クラス名closeを付与
	}
});

//ページが読み込まれた際にopenクラスをつけ、openがついていたら開く動作※不必要なら下記全て削除
$(window).on('load', function(){
	$('.accordion-area li:first-of-type section').addClass("open"); //accordion-areaのはじめのliにあるsectionにopenクラスを追加
	$(".open").each(function(index, element){	//openクラスを取得
		var Title =$(element).children('.accordion-title');	//openクラスの子要素のtitleクラスを取得
		$(Title).addClass('close');				//タイトルにクラス名closeを付与し
		var Box =$(element).children('.accordion-box');	//openクラスの子要素boxクラスを取得
		$(Box).slideDown(500);					//アコーディオンを開く
	});
});

/*---------------------------------------------
	fade-out
---------------------------------------------*/
if (window.matchMedia( "(max-width: 767px)" ).matches) {
	$(function(){
		var scrollend = $('#demo02__area').offset().top + 0; //ページ上部からプラス50pxした距離を取得
		var distance = 0;
		$(document).scroll(function(){
			distance = $(this).scrollTop(); //スクロールした距離を取得
			if (scrollend <= distance) {
				$('.js-demo02-btn-area').fadeOut();
			} else{
				$('.js-demo02-btn-area').fadeIn();
			}
		});
	});
	/* ウィンドウサイズが 768px以下の場合のコードをここに */
	}